module.exports = __webpack_public_path__ + "img/java.8de5236f.svg";